import AdminCalendar from '../AdminCalendar/AdminCalendar.jsx';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../../context/AuthContext';
import { toast } from '../../../common/Toast/toast';

const TrainerCalendar = () => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const hasShownToast = useRef(false);

  useEffect(() => {
    const canView =
      hasPermission('trainer-calendar', 'view', 'lms') ||
      hasPermission('trainer-calender', 'view', 'lms');
    if (!canView && !hasShownToast.current) {
      toast.error('You do not have permission to access calendar.');
      hasShownToast.current = true;
      navigate('/');
    }
  }, [hasPermission, navigate]);

  return <AdminCalendar/>;
};

export default TrainerCalendar;
